export type MobileValue = string | null;
